import React, { useState, useCallback } from 'react';
import { Table, Spinner, Form, Button } from 'react-bootstrap';
import debounce from 'lodash/debounce';
import { swalConfirm } from 'components/utilities/SwalToastUtil';
import {
  getByEmplasCode,
  getBySupplierCode
} from 'services/stock-location/productService';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';

const StockCheckTable = ({ data, columns, loading, useAddedRow = false, onRowAdded }) => {
  const [tableData, setTableData] = useState(data);
  const [newRow, setNewRow] = useState({});
  const [isValidCode, setIsValidCode] = useState(true);
  const debouncedGetByEmplasCode = useCallback(
    debounce(async (value, rowIndex, isNewRow) => {
      console.log(value, rowIndex, isNewRow);

      if (!value) return;

      const result = await getByEmplasCode(value);
      console.log(result);

      if (result?.data) {
        setIsValidCode(result.data.productId > 0);

        if (isNewRow) {
          setNewRow(prev => ({
            ...prev,
            productId: result.data.productId,
            description: result.data.productDescription,
            supplierCode: result.data.supplierCode,
            mUnitStock: result.data.mUnitStock,
            packQty: result.data.packSize,
          }));
        } 
      }
    }, 1000),
    []
  );

  const debouncedGetBySupplierCodes = useCallback(
    debounce(async (value, rowIndex, isNewRow) => {
      console.log(value, rowIndex, isNewRow);

      if (!value) return;

      const result = await getBySupplierCode(value);
      console.log(result);

      if (result?.data) {
        setIsValidCode(result.data.productId > 0);

        if (isNewRow) {
          console.log(result);
          setNewRow(prev => ({
            ...prev,
            productId: result.data.productId,
            description: result.data.productDescription,
            emplasCode: result.data.productCode,
            supplierCode: result.data.supplierCode,
            mUnitStock: result.data.mUnitStock,
            packQty: result.data.packSize,
          }));
        } else {
          setTableData(prev => {
            const updatedData = [...prev];
            if (updatedData[rowIndex]) {
              updatedData[rowIndex] = {
                ...updatedData[rowIndex],
                description: result.data.productDescription,
              };
            }
            return updatedData;
          });
        }
      }
    }, 1000),
    []
  );

  const handleInputChange = (e, rowIndex, accessor, type, isNewRow) => {
    let value = e.target.value;
    if (type === 'number') {
      value = value.replace(/[^0-9]/g, '');
    }

    if (isNewRow) {
      setNewRow(prev => ({ ...prev, [accessor]: value }));
      if (accessor === 'emplasCode') {
        debouncedGetByEmplasCode(value, rowIndex, true);
      }
      if (accessor === 'supplierCode') {
        debouncedGetBySupplierCodes(value, rowIndex, true);
      }
    } else {
      setTableData(prev => {
        const updatedData = [...prev];
        updatedData[rowIndex] = { ...updatedData[rowIndex], [accessor]: value };
        return updatedData;
      });

      if (accessor === 'emplasCode') {
        debouncedGetByEmplasCode(value, rowIndex, false);
      }
      if (accessor === 'supplierCode') {
        debouncedGetBySupplierCodes(value, rowIndex, true);
      }
    }
  };
  const handleCheckQuantity = (packQty, mUnitsStock, count) => {
    console.log(packQty, mUnitsStock, count);
    if (packQty * mUnitsStock < count) {
      swalConfirm(
        'Higher count than stock, are you sure?',
        '',
        () => {
          console.log('confirm');
        },
        () => {
          setNewRow(prev => ({ ...prev, count: 0 }));
        }
      );
    }
  };
  const handleAddRow = () => {
    const missingFields = columns
      .filter(
        col =>
          col.required && (!newRow[col.accessor] || newRow[col.accessor] === '')
      )
      .map(col => col.Header);
    if (!isValidCode) {
      toast.error(
        <BasicTemplate
          success={false}
          text={`Code Not found: EmplasCode: ${newRow.emplasCode} - SupplierCode: ${newRow.supplierCode}`}
        />
      );
      return;
    }
    if (missingFields.length > 0) {
      toast.error(
        <BasicTemplate
          success={false}
          text={`Missing fields: ${missingFields.join(', ')}`}
        />
      );
      return;
    }
    const updatedData = {
      ...newRow,
      actualCountLengthPacks: newRow.packQty,
      actualCountMetresEach: newRow.mUnitStock
    }
    console.log([...tableData, updatedData])
    setTableData([...tableData, updatedData]);
    onRowAdded([...tableData, updatedData]);
    setNewRow({});
    // setForceUpdateKey(prev => prev + 1);
  };

  return (
    <Table striped bordered hover>
      <thead className="bg-200 text-900 align-middle">
        <tr>
          {columns.map((col, index) => (
            <th key={index} className={col.required ? 'required' : ''}>
              {col.Header}
            </th>
          ))}
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr className="text-center">
            <td colSpan={columns.length + 1}>
              <Spinner animation="border" role="status" />
            </td>
          </tr>
        ) : (
          tableData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={colIndex}>
                  <Form.Control
                    type={col.type === 'number' ? 'text' : 'text'}
                    placeholder={`Enter ${col.Header}`}
                    value={row[col.accessor] || ''}
                    // onChange={(e) => handleInputChange(e, rowIndex, col.accessor, col.type, false)}
                    disabled
                  />
                </td>
              ))}
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => {
                    setTableData(tableData.filter((_, i) => i !== rowIndex));
                    onRowAdded(tableData.filter((_, i) => i !== rowIndex));
                  }}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))
        )}

        {/* Dòng nhập dữ liệu mới */}
        {useAddedRow && <tr>
          {columns.map((col, index) => (
            <td key={index}>
              <Form.Control
                type={col.type === 'number' ? 'text' : 'text'}
                placeholder={`Enter ${col.Header}`}
                value={newRow[col.accessor] || ''}
                disabled={newRow[col.accessor + 'Disabled'] == true || col.disabled == true}
                onChange={e =>
                  handleInputChange(
                    e,
                    tableData.length,
                    col.accessor,
                    col.type,
                    true
                  )
                }
                onBlur={() =>
                  handleCheckQuantity(
                    newRow.packQty,
                    newRow.mUnitStock,
                    newRow.count
                  )
                }
              />
            </td>
          ))}
          <td>
            <Button variant="success" size="sm" onClick={handleAddRow}>
              Add
            </Button>
          </td>
        </tr>}

      </tbody>
    </Table>
  );
};

StockCheckTable.propTypes = {
  data: PropTypes.object,
  columns: PropTypes.array,
  loading: PropTypes.bool,
  useAddedRow: PropTypes.bool,
  onRowAdded: PropTypes.func,
};

export default StockCheckTable;
